export type SearchedField<Row> = { key: string; values: (row: Row) => (string | null | undefined)[] };

export type SearchHit = { field: string; value: string };

const contains = (value: string, term: string) =>
  value.toLocaleLowerCase("nb").includes(term.toLocaleLowerCase("nb"));

export const searchHitOutsideShownColumns = <Row>(
  fields: SearchedField<Row>[],
  row: Row,
  term: string | null | undefined,
  shownColumns: Set<string>,
): SearchHit | null => {
  const searched = term?.trim();
  if (!searched) return null;
  const hits = fields.flatMap((field) =>
    field
      .values(row)
      .filter((value): value is string => !!value && contains(value, searched))
      .map((value) => ({ field: field.key, value })),
  );
  if (hits.some((hit) => shownColumns.has(hit.field))) return null;
  return hits[0] ?? null;
};
